import { AboveBelowFieldsContentType } from 'common.types'
import Accordion from 'components/Accordion/Accordion'
import { useDynamicFormContent } from 'hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const VoterRegAboveFieldsContent: React.FC<
  AboveBelowFieldsContentType
> = ({ step }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.aboveFieldsContent`,
  })
  const { formContent } = useDynamicFormContent()
  const dates = formContent?.dates

  return (
    <>
      {step === 1 && (
        <div
          dangerouslySetInnerHTML={{
            __html: t(`disclosureOne`, {
              electionDay: dates?.electionDay,
              voterRegistrationDeadline: dates?.voterRegistrationDeadline,
            }),
          }}
        ></div>
      )}
      {step === 1 && (
        <Accordion
          title={t(`disclosureThree.title`)}
          content={t(`disclosureThree.content`)}
        />
      )}
    </>
  )
}
